import React from 'react';
import ReactDOM from "react-dom";
import YouTube from "react-youtube";
import VideoPlayer from "./video-player";

class VideoLauncher extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isVideoOpen: false
        };
        this.launchVideo = this.launchVideo.bind(this);
    }

    launchVideo() {
        this.setState({
            isVideoOpen: !this.state.isVideoOpen
        });
        if (typeof gtag !== 'undefined') {
            gtag('event', `${this.props.gaAction}`, { 'event_category': 'Video', 'event_label': `${this.props.gaLabel}` });
        }

    }

    render() {
        const isVideoOpen = this.state.isVideoOpen;
        let videoPlayer;

        if (isVideoOpen) {
            videoPlayer =
                <VideoPlayer
                videoId={this.props.videoId}
                onClose={this.launchVideo}
                isOpen={this.state.isVideoOpen}
                />;
        }



        return (
            <div className="video-player">
                <a href="#" onClick={this.launchVideo}>
                    <span className="video-icon" />
                    <img src={this.props.videoImage} alt={this.props.videoDescription} />
                </a>
                {videoPlayer}
            </div>
        );
    }
}

export default VideoLauncher;
